class ApiUtils {
    static post(url, body) {
        return this.callURL(url, body, 'post');
    }

    static postFile(url, token, file) {
        return this.callURLFile(url, token, file, 'post');
    }

    static get(url, body) {
        return this.callURL(url, body, 'get');
    }

    // eslint-disable-next-line no-dupe-class-members
    static get(url) {
        return this.callURLNoBody(url, 'get');
    }

    static getAuth(url, param) {
        return this.callURLAuth(url, param, 'get')
    }

    static callURL(url, body, method) {
        return fetch(url, {
            method: method,
            mode: 'cors',
            credentials: 'same-origin',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(body),
        }).then((response) => {
            return Promise.all([Promise.resolve(response), response.json()]);
        })
    }

    static callURLNoBody(url, method) {
        return fetch(url, {
            method: method,
            mode: 'cors',
            credentials: 'same-origin',
            headers: {
                'Content-Type': 'application/json',
            },
        }).then((response) => {
            return Promise.all([Promise.resolve(response), response.json()]);
        })
    }

    static callURLAuth(url, param, method) {
        return fetch(url, {
            method: method,
            mode: 'cors',
            credentials: 'same-origin',
            headers: {
                'Authorization': `Bearer ${param}`,
            },
        }).then((response) => {
            return Promise.all([Promise.resolve(response), response.json()]);
        })
    }

    static callURLFile(url, token, file, method) {
        let formData = new FormData();
        formData.append('file', file)
        return fetch(url, {
            method: method,
            mode: 'cors',
            credentials: 'same-origin',
            headers: {
                'Authorization': `Bearer ${token}`,
            },
            body: formData
        }).then((response) => {
            return Promise.all([Promise.resolve(response), response.json()]);
        })
    }
}

export default ApiUtils
